import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=cdd8ce96&scoped=true"
import script from "./Load.vue?vue&type=script&lang=js"
export * from "./Load.vue?vue&type=script&lang=js"
import style0 from "./Load.vue?vue&type=style&index=0&id=cdd8ce96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd8ce96",
  null
  
)

export default component.exports